import axios from "axios";

export const getDepartments = async (companyId) => {
const response = await axios.get(`api/departments?companyId=${companyId}`);	
    const result = response.data;
    return result;
}

export const postDepartment = async (data) => {
    const response = await axios.post("api/departments", data);
    const result = response.data;
    return result;
}

export const patchDepartment = async (data) => {
    const response = await axios.patch("api/departments", data);
    const result = response.data;
    return result;
}

export const deleteDepartment = async (id) => {
    const response = await axios.delete(`api/departments/${id}`);
    const result = response.data;
    return result;
}
